export type CsRenewalProductCardPayload = {
  spaceId?: string;
  spaceProductId?: string;
  productName?: string;
  productDescription?: string;
  posterUrl?: string;
  priceLabels?: string[];
  subscribePathH5?: string;
  subscribePathWeb?: string;
};

export function parseCsRenewalProductCardContent(content: string): CsRenewalProductCardPayload | null {
  if (!content?.trim()) return null;
  try {
    const raw = JSON.parse(content) as CsRenewalProductCardPayload;
    if (!raw || typeof raw !== "object") return null;
    return raw;
  } catch {
    return null;
  }
}

export function truncateCsRenewalDescription(text?: string, maxLen = 28): string {
  const s = text?.trim() ?? "";
  if (!s) return "";
  if (s.length <= maxLen) return s;
  return `${s.slice(0, maxLen)}...`;
}
